export const defaultContainerToastCss = {
	backgroundColor: 'white',
	mb: 1,
}
